import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.areaData = JSON.parse(JSON.stringify(this.Queries.SQL1))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.overall  = json.overall
      this.circle   = json.circle
      this.area     = json.area
      this.colors   = json.colors

      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries  = json.sundries
      

      this.circle.phase.forEach((d,i)=> {
        d.color = this.colors[this.overall.color][i]
      })


      this.currnet = {phase: 'Overall'}

    }
  }
}